import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import ApiService from '@/services/api.service'
import { VERIFY_AUTH } from '@/store/auth.module'
import { INITIALIZE_GEO_INFO } from '@/store'
import LoadScript from 'vue-plugin-load-script'
import 'bootstrap'
import 'owl.carousel'
import 'magnific-popup'
import 'theia-sticky-sidebar'
import 'flexslider'
import 'jquery.mmenu'
import 'hideshowpassword'
import 'ion-rangeslider'
import 'sticky-kit/dist/sticky-kit'
import BootstrapVue from 'bootstrap-vue'
import 'daterangepicker'
import { GET_CITIES } from '@/store/cities.module'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import VueSocialSharing from 'vue-social-sharing'
import Vuelidate from 'vuelidate'
import i18n from '@/plugins/vue-i18n'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Toast, { POSITION } from 'vue-toastification'
import {
  initCookieConsent,
  initGoogleAnalytics,
  onCategoryAccepted,
  trackGoogleAnalyticsPageView,
} from '@/utils/cookieConsent'
// import 'swiper/dist/css/swiper.css' // v4 CSS
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'swiper/css/swiper.css'
import 'vue-toastification/dist/index.css'

import * as Sentry from '@sentry/vue'

Sentry.init({
  Vue,
  dsn: 'https://e95255bce56d365ed354d4e99ddd2d4a@o4511438711619584.ingest.de.sentry.io/4511438720925776',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    'https://adabojanaforme-be-production.up.railway.app',
    /^https:\/\/yourserver\.io\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Logs
  enableLogs: true
})

Vue.use(VueAwesomeSwiper)

window.$ = window.jQuery = require('jquery')

const jQueryBridget = require('jquery-bridget')
const Isotope = require('isotope-layout')
// noinspection JSValidateTypes
jQueryBridget('isotope', Isotope, window.$)

const WOW = require('wowjs')
window.wow = new WOW.WOW({
  boxClass: 'wow',
  animateClass: 'animated',
  offset: 0,
  mobile: true,
  live: false,
  scrollContainer: null,
})

window.wow.init()

Vue.use(VueMeta)
// noinspection JSCheckFunctionSignatures
Vue.use(LoadScript)
Vue.use(BootstrapVue)
Vue.use(VueSocialSharing)
// noinspection JSCheckFunctionSignatures
Vue.use(Vuelidate)
Vue.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
})

Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    getDisplayCurrency() {
      const fromStore = this.$store?.getters?.geoInfo?.currency
      const fromSession =
        typeof window !== 'undefined' && window.sessionStorage
          ? window.sessionStorage.getItem('userCurrency')
          : ''
      const raw = typeof fromStore === 'string' && fromStore.trim() ? fromStore : fromSession
      const currency = typeof raw === 'string' ? raw.trim().toUpperCase() : ''
      return currency || 'EUR'
    },
    formatPriceNumber(value) {
      const amount = Number(value)
      if (!Number.isFinite(amount)) return ''
      const currency = this.getDisplayCurrency()
      if (currency !== 'EUR') {
        return Math.round(amount).toLocaleString('en-US')
      }
      return String(amount)
    },
    formatPriceWithCurrency(value) {
      const formattedAmount = this.formatPriceNumber(value)
      if (!formattedAmount) return ''
      const currency = this.getDisplayCurrency()
      if (currency !== 'EUR') return `${currency} ${formattedAmount}`
      return `€${formattedAmount}`
    },
    getImageUrl(url) {
      if (!url) return '/img/placeholder.jpg'
      if (url.startsWith('http')) return url
      return (
        process.env.VUE_APP_ASSETS_BASE ||
        'https://adabojana-for-me.b-cdn.net/'
      ) + url
    },
  },
})

ApiService.init()
store.dispatch(INITIALIZE_GEO_INFO).catch(() => {})
initCookieConsent()

const gaMeasurementId = process.env.VUE_APP_GA_MEASUREMENT_ID || 'G-N43K2NSG2F'

onCategoryAccepted(
  'analytics',
  () => {
    initGoogleAnalytics(gaMeasurementId).then(() => {
      trackGoogleAnalyticsPageView(router.currentRoute.fullPath)
    })
  },
  { once: true, immediate: true }
)

router.beforeEach((to, from, next) => {
  // Do not block navigation on data prefetches; render immediately and hydrate async.
  store.dispatch(VERIFY_AUTH)
  if (!store.getters.cities?.length) {
    store.dispatch(GET_CITIES, { only: ['id', 'title', 'slug'] })
  }
  next()
})

router.afterEach((to) => {
  trackGoogleAnalyticsPageView(to.fullPath)
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
